import { Box, Grid, Tooltip } from '@mui/material'
import React, { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { useRecoilValue } from 'recoil';
import AppSelectList from "../../../Component/Common/Components/FormValidationInputs/AppSelectList";
import { ratingList } from "../../../Component/Common/Constants/Lists/DropdownListOptions";
import {
    VerificationAgencyClientService
} from "../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService";
import AppTextInput from "../../../Component/Common/Components/FormValidationInputs/AppTextInput";
import { VerificationCompanyAtom } from "../../../State/VerificationCompany.Atom";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import AppYesOrNoSelector from "../../../Component/Common/Components/FormValidationInputs/AppYesOrNoSelector";
import { IntermediateGlobalLoading } from '../../../Component/Common/Components/Loading/IntermediateGlobalLoading';

export const FeedbackDetails = () => {

    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const [referenceNumber, setReferenceNumber] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const { control, reset, watch } = useForm({
        mode: 'all',
    });

    const getFeedbackDetails = async () => {

        if (verificationCompany.feedbackId !== -1) {
            try {
                const response = await VerificationAgencyClientService.GetFeedbackById(verificationCompany.feedbackId);
                const formData = {
                    companyName: verificationCompany.company,
                    clientName: response.data.clientName,
                    analystName: response.data.analystName,
                    isSatisfied: response.data.isSatisfied,
                    reason: response.data.reason,
                    isRequirementsUnderstood: response.data.isRequirementsUnderstood,
                    isProfessional: response.data.isProfessional,
                    analystRating: response.data.analystRating,
                    premierRating: response.data.premierRating,
                    wouldRefer: response.data.wouldRefer,
                    improvementFeedback: response.data.improvementFeedback,
                };
                reset(formData);
                setReferenceNumber(response.data.referenceNumber);
            } catch (error) {
                console.log(error);
            }
        }
    }

    const fetchData = async () => {
        setLoading(true);
        await getFeedbackDetails();
        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, [verificationCompany.feedbackId]);

    const isSatisfied = watch("isSatisfied");
    const showReason = Boolean(isSatisfied);
    
    if (loading) {
        return (<IntermediateGlobalLoading />);
    }
    return (
        <Box>
            <MDTypography graphy color='primary' variant='h6' fontWeight='bold' sx={{ mb: 2 }} >
                Feedback Details - {referenceNumber}
            </MDTypography>
            <Grid container spacing={3} component="form" id='FeedbackDetailsForm'>
                <Grid item xs={6}>
                    <Box mt={2}>
                        <AppTextInput control={control} name="companyName" label="Name of Company" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppTextInput control={control} name="clientName" label="What is your name and surname?" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppTextInput control={control} name="analystName" label="Who was your verification analyst?" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="isSatisfied" label='Are you satisfied with your verification result?' size="small" disabled={true} />
                    </Box>
                    {!showReason &&
                        <Box mt={2}>
                            <AppTextInput control={control} name="reason" label="If not, please elaborate?" size={"small"} multiline={true} rows={4} disabled={true} />
                        </Box>
                    }
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="isRequirementsUnderstood" label='Did the verification analyst understand your organisations BBBEE Requirements?' size="small" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="isProfessional" label='Did your verification analyst conduct themselves in a professional manner at all times?' size="small" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppSelectList control={control} name='analystRating' label='How would you rate your experience with your verification analyst?' items={ratingList} size="small" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppSelectList control={control} name='premierRating' label='Overall, how would you rate your experience with the Verification Agency?' items={ratingList} size="small" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="wouldRefer" label='Would you refer the Verification Agency`s services to anyone else?' size="small" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppTextInput control={control} name="improvementFeedback" label="Is there anything we could have done to improve your verification experience?" size={"small"} multiline={true} rows={4} disabled={true} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}
